import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "talk-sidebar"
}
const _hoisted_2 = {
  key: 0,
  class: "emptycontent"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TopBar = _resolveComponent("TopBar")
  const _component_CallView = _resolveComponent("CallView")
  const _component_InternalSignalingHint = _resolveComponent("InternalSignalingHint")
  const _component_RouterView = _resolveComponent("RouterView")
  const _component_PollManager = _resolveComponent("PollManager")
  const _component_PollViewer = _resolveComponent("PollViewer")
  const _component_MediaSettings = _resolveComponent("MediaSettings")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")

  return (_openBlock(), _createBlock(_component_TransitionWrapper, { name: "slide-right" }, {
    default: _withCtx(() => [
      ($options.isOpen)
        ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
            (!$options.token)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "icon icon-talk" }, null, -1)),
                  _createElementVNode("h2", null, _toDisplayString($options.t('spreed', 'This conversation has ended')), 1)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_TopBar, {
                    "is-in-call": "",
                    "is-sidebar": ""
                  }),
                  _createVNode(_component_CallView, {
                    token: $options.token,
                    "is-sidebar": ""
                  }, null, 8, ["token"]),
                  _createVNode(_component_InternalSignalingHint),
                  _createVNode(_component_RouterView),
                  _createVNode(_component_PollManager),
                  _createVNode(_component_PollViewer),
                  _createVNode(_component_MediaSettings, {
                    "recording-consent-given": $data.recordingConsentGiven,
                    "onUpdate:recordingConsentGiven": _cache[0] || (_cache[0] = $event => (($data.recordingConsentGiven) = $event))
                  }, null, 8, ["recording-consent-given"])
                ], 64))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}